import { FC, useRef } from 'react'
import Image from 'next/image'
import clsx from 'clsx'

import { STATIC_URL } from 'constants/data'

import styles from './input.module.scss'

const imgPath = {
  iconClose: `${STATIC_URL}/filters/icon_close.svg`,
}

interface IInput extends React.InputHTMLAttributes<HTMLInputElement> {
  modificator?: string
  sideIconModificator?: string
  wrapperModificator?: string
  sideIconPath?: string
  resetButton?: boolean
  onResetClick?: (inputValue: string) => void
}

const Input: FC<IInput> = ({
  modificator,
  sideIconModificator,
  wrapperModificator,
  sideIconPath,
  resetButton,
  onResetClick,
  ...props
}: IInput) => {
  const inputEl = useRef<HTMLInputElement>(null)
  if (props.disabled && inputEl !== null && inputEl.current !== null) inputEl?.current?.blur()

  const handleReset = () => {
    if (inputEl.current && onResetClick) {
      inputEl.current.value = ''
      onResetClick(inputEl.current.value)
    }
  }

  return (
    <div
      className={clsx(styles.inputWrapper, { [wrapperModificator as string]: wrapperModificator })}
    >
      <input
        ref={inputEl}
        className={clsx(styles.input, {
          [modificator as string]: modificator,
          [styles.inputGotIcon]: sideIconPath,
        })}
        {...props}
      />
      {sideIconPath && (
        <div
          className={clsx(styles.inputIcon, {
            [sideIconModificator as string]: sideIconModificator,
          })}
        >
          <Image src={sideIconPath} width="16" height="16" alt="Поиск" />
        </div>
      )}
      {resetButton && inputEl?.current?.value && (
        <div className={styles.inputReset} onClick={handleReset}>
          <Image src={imgPath.iconClose} width="10" height="10" alt="Очистить" />
        </div>
      )}
    </div>
  )
}

export default Input
